import { makeResource } from '@codium/codium-vue'
import { storeModule as screenTags } from './settings/screen-tags'
import { storeModule as mediaOwnerTags } from './settings/media-owner-tags'
import { storeModule as mediaOwnerScreenTags } from './settings/media-owner-screen-tags'
import { storeModule as integrations } from './settings/integrations'
import { storeModule as reportRules } from './settings/report-rules'
import { storeModule as energyProviders } from './settings/energy-providers'
import { storeModule as railAppReleases } from './settings/rail-app-releases'
import { http } from '@/utils'

export const { storeModule, helperComputed, helperMethods, stateMapper } = makeResource('settings', {
  modules: {
    screenTags,
    mediaOwnerTags,
    reportRules,
    mediaOwnerScreenTags,
    integrations,
    railAppReleases,
    energyProviders
  },
  storeModule: {
    mutations: {
      SET_USER_SETTINGS (state, { items, total }) {
        state.settings = items
        state.total = total
      }
    },
    actions: {
      async getUserSettings ({ commit }, { page = 1 }) {
        const response = await http.get('/user/settings', {
          params: {
            page,
          }
        })
        commit('SET_USER_SETTINGS', {
          items: response.data.data,
          total: response.data.meta.total,
        })
      }
    }
  },
  resource () {
    return {
    }
  }
})
